export default {"src":"/_next/static/media/up-arrow.6c04d343.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};